import { Metadata } from '../../models/metadata';
/**
 * This is the search response details inside the SearchResponse object that contains
 * the search results, under the `docs` key.
 *
 * @export
 * @class Response
 */
export class SearchResponseDetails {
    constructor(json) {
        this.numFound = json.numFound;
        this.start = json.start;
        this.docs = json.docs.map((doc) => new Metadata(doc));
        this.aggregations = json.aggregations;
    }
}
//# sourceMappingURL=search-response-details.js.map